<template>
  <el-container style="height: 100%" class="fra">
    <!-- <pagesider
      class="fra-sider"
      v-show="!pageScroll.scroll && !siderConfig.isHide"
    ></pagesider> -->
    <!-- <pageheader
      class="fra-header"
      :class="{ 'is-collapsed': siderConfig.isMenuCollapse }"
      v-show="!pageScroll.scroll && !siderConfig.isHide"
    ></pageheader> -->
    <transition :name="pageTransition">
      <!-- <router-view v-if="isReloadAlive" ref="imagePage"></router-view> -->
      <keep-alive
        :include="
          $store.state.routerTabList.map((v) => v.keepAliveName).join(',')
        "
      >
        <router-view v-if="isReloadAlive" ref="imagePage"></router-view>
      </keep-alive>
    </transition>
    <div class="scrolltool" v-if="pageScroll.scroll && !siderConfig.hideMenu">
      <h4>
        {{ $l("滚动模式：") }}
        <span v-if="pageScroll.mode == 'auto'">{{ $l("自动播放") }} </span>
        <span v-else>{{ $l("手动播放") }} </span>
      </h4>
      <el-button
        icon="el-icon-back"
        round
        @click="prevPage"
        v-show="pageScroll.mode == 'manual'"
      ></el-button>
      <div class="scrolltool-num">
        {{ curPageNum }} / {{ pageScroll.scrollList.length }}
      </div>
      <el-button
        icon="el-icon-right"
        round
        @click="nextPage"
        v-show="pageScroll.mode == 'manual'"
      ></el-button>
      <el-button type="primary" round @click="exitPageScroll" class="exit"
        >{{ $l("退出滚动") }}
      </el-button>
    </div>
    <span
      v-if="
        pageScroll.scrollList.filter((item) => item.name == 'alarm').length == 1
      "
    >
      <alarm ref="alarm" :loaded="false" v-show="false"></alarm>
    </span>
    <span
      v-if="
        pageScroll.scrollList.filter((item) => item.name == 'device').length ==
        1
      "
    >
      <device ref="device" :loaded="false" v-show="false"></device>
    </span>
    <span
      v-if="
        pageScroll.scrollList.filter((item) => item.name == 'faultReport')
          .length == 1
      "
    >
      <faultReport
        ref="faultReport"
        :loaded="false"
        v-show="false"
      ></faultReport>
    </span>
    <span
      v-if="
        pageScroll.scrollList.filter((item) => item.name == 'message').length ==
        1
      "
    >
      <message ref="message" :loaded="false" v-show="false"></message>
    </span>
    <span
      v-if="
        pageScroll.scrollList.filter((item) => item.name == 'monitor').length ==
        1
      "
    >
      <monitor ref="monitor" :loaded="false" v-show="false"></monitor>
    </span>
    <span
      v-if="
        pageScroll.scrollList.filter((item) => item.name == 'maintainManage')
          .length == 1
      "
    >
      <maintainManage
        ref="maintainManage"
        :loaded="false"
        v-show="false"
      ></maintainManage>
    </span>
    <span
      v-if="
        pageScroll.scrollList.filter((item) => item.name == 'maintainMsg')
          .length == 1
      "
    >
      <maintainMsg
        ref="maintainMsg"
        :loaded="false"
        v-show="false"
      ></maintainMsg>
    </span>
    <span
      v-if="
        pageScroll.scrollList.filter((item) => item.name == 'supervise')
          .length == 1
      "
    >
      <supervise ref="supervise" :loaded="false" v-show="false"></supervise>
    </span>
    <span
      v-if="
        pageScroll.scrollList.filter((item) => item.name == 'account').length ==
        1
      "
    >
      <account ref="account" :loaded="false" v-show="false"></account>
    </span>
    <span
      v-if="
        pageScroll.scrollList.filter((item) => item.name == 'feedback')
          .length == 1
      "
    >
      <feedback ref="feedback" :loaded="false" v-show="false"></feedback>
    </span>
    <span
      v-if="
        pageScroll.scrollList.filter((item) => item.name == 'lift').length == 1
      "
    >
      <lift ref="lift" :loaded="false" v-show="false"></lift>
    </span>
    <span
      v-if="
        pageScroll.scrollList.filter((item) => item.name == 'log').length == 1
      "
    >
      <log ref="log" :loaded="false" v-show="false"></log>
    </span>
    <span
      v-if="
        pageScroll.scrollList.filter((item) => item.name == 'role').length == 1
      "
    >
      <role ref="role" :loaded="false" v-show="false"></role>
    </span>
    <span
      v-if="
        pageScroll.scrollList.filter((item) => item.name == 'index').length == 1
      "
    >
      <index ref="index" :loaded="false" v-show="false"></index>
    </span>
  </el-container>
</template>

<script>
// @ is an alias to /src
import pagesider from "@/components/pagesider.vue";
import pageheader from "@/components/pageheader.vue";
import alarm from "@/views/manage/alarm.vue";
import device from "@/views/manage/device.vue";
import faultReport from "@/views/manage/faultReport.vue";
import message from "@/views/manage/message.vue";
import monitor from "@/views/manage/monitor.vue";
import maintainManage from "@/views/maintain/maintainManage.vue";
import maintainMsg from "@/views/maintain/maintainMsg.vue";
import supervise from "@/views/maintain/supervise.vue";
import account from "@/views/setting/account.vue";
import feedback from "@/views/setting/feedback.vue";
import lift from "@/views/setting/lift.vue";
import log from "@/views/setting/log.vue";
import proprietor from "@/views/setting/proprietor.vue";
import role from "@/views/setting/role.vue";
import index from "@/views/Index.vue";

import global from "@/mixins/global.js";

export default {
  name: "fra",
  mixins: [global],
  components: {
    pagesider,
    pageheader,
    alarm,
    device,
    faultReport,
    message,
    monitor,
    maintainManage,
    maintainMsg,
    supervise,
    account,
    feedback,
    lift,
    log,
    proprietor,
    role,
    index,
  },
  data() {
    return {
      isReloadAlive: true,
      // interval: "",
      pageTransition: "none",
      imagePagePath: "/display/imagePage", //跑马灯页面path
      carouselImgIndex: "",
      curIndex: "", //当前页面在页面列表类型为page的序号,
    };
  },
  methods: {
    autoPageScroll() {
      this.$store.state.interval = setInterval(() => {
        this.$store.commit("setPageIndex", this.$store.state.curPageIndex + 1);
        let page = this.pageScroll.scrollList.filter(
          (item) => item.index == this.$store.state.curPageIndex
        )[0];
        this.$router.push(page.path);
      }, this.pageScroll.interval);
    },
    stopPageScroll() {
      clearInterval(this.$store.state.interval);
    },
    exitPageScroll() {
      if (this.$store.state.indexLiftStatusTimer) {
        window.clearInterval(this.$store.state.indexLiftStatusTimer);
      }
      this.$store.state.indexLiftStatusTimer = -1;
      if (this.$store.state.indexDeviceStatusTimer) {
        window.clearInterval(this.$store.state.indexDeviceStatusTimer);
      }
      this.$store.state.indexDeviceStatusTimer = -1;
      if (this.$store.state.indexRealTimer) {
        window.clearTimeout(this.$store.state.indexRealTimer);
      }
      this.$store.state.indexRealTimer = -1;
      if (this.$store.state.indexMapTimer) {
        window.clearInterval(this.$store.state.indexMapTimer);
      }
      this.$store.state.indexMapTimer = -1;
      if (this.$store.state.checkIndexRealTimer) {
        window.clearInterval(this.$store.state.checkIndexRealTimer);
      }
      this.$store.state.checkIndexRealTimer = -1;
      if (this.$store.state.deviceLiftStatusTimer) {
        window.clearTimeout(this.$store.state.deviceLiftStatusTimer);
      }
      this.$store.state.deviceLiftStatusTimer = -1;
      if (this.$store.state.alarmMonitorStatusTimer) {
        window.clearTimeout(this.$store.state.alarmMonitorStatusTimer);
      }
      this.$store.state.alarmMonitorStatusTimer = -1;
      if (this.$store.state.monitorStatusTimer) {
        window.clearTimeout(this.$store.state.monitorStatusTimer);
      }
      this.$store.state.allDayMonitorTimer = -1;
      if (this.$store.state.allDayMonitorTimer) {
        window.clearTimeout(this.$store.state.allDayMonitorTimer);
      }
      this.$store.state.switchMonitorTimer = -1;
      if (this.$store.state.switchMonitorTimer) {
        window.clearInterval(this.$store.state.switchMonitorTimer);
      }
      this.$store.state.monitorStatusTimer = -1;
      this.pageScroll.scrollList.forEach((item, index) => {
        sessionStorage.removeItem(item.name + "_data_list");
        sessionStorage.removeItem(item.name + "_data_total");
      });
      if (this.realMonitorTimer) {
        window.clearTimeout(this.realMonitorTimer);
        this.realMonitorTimer = null;
      }
      if (this.$store.state.ws) {
        this.$store.state.ws.close();
        this.$store.commit("setWS", null);
      }
      this.stopPageScroll();
      this.outFullScreen();
      this.$store.commit("exitPageScroll");
      this.$store.commit("setPageIndex", 1);
      if (this.$route.path != "/display") {
        this.$router.push("/display");
      }
    },
    nextPage() {
      this.pageTransition = "slide-left";
      this.$store.commit("setPageIndex", this.$store.state.curPageIndex + 1);
      let page = this.pageScroll.scrollList.filter(
        (item) => item.index == this.$store.state.curPageIndex
      )[0];
      if (page.path == this.imagePagePath) {
        if (this.$refs["imagePage"].nextImage) {
          this.$refs["imagePage"].nextImage(page);
        } else {
          this.$router.push(page.path);
        }
      } else {
        this.$router.push(page.path);
      }
    },
    prevPage() {
      this.pageTransition = "slide-right";
      this.$store.commit("setPageIndex", this.$store.state.curPageIndex - 1);
      let page = this.pageScroll.scrollList.filter(
        (item) => item.index == this.$store.state.curPageIndex
      )[0];
      if (page.path == this.imagePagePath) {
        if (this.$refs["imagePage"].prevImage) {
          this.$refs["imagePage"].prevImage();
        } else {
          this.$router.push({
            path: page.path,
            query: {
              back: true,
            },
          });
        }
      } else {
        this.$router.push({
          path: page.path,
          query: {
            back: true,
          },
        });
      }
    },
  },
  provide() {
    return {
      reload: this.reload,
      autoPageScroll: this.autoPageScroll,
      stopPageScroll: this.stopPageScroll,
    };
  },
  mounted() {
    if (this.pageScroll.scroll) {
      this.pageTransition = "slide-left";
    } else {
      this.pageTransition = "el-fade-in-linear";
    }
    this.$nextTick(() => {
      window.onresize = () => {
        if (!this.checkFull() && this.pageScroll.scroll) {
          this.exitPageScroll();
        }
      };
      document.addEventListener("keyup", (e) => {
        //此处填写你的业务逻辑即可
        if (e.keyCode == 27 && this.pageScroll.scroll) {
          this.exitPageScroll();
        }
      });
    });
  },
  created() {
    this.user = this.$store.state.user;
  },
  computed: {
    pageScroll() {
      return this.$store.state.pageScroll;
    },
    curPageNum() {
      return this.$store.state.curPageIndex; //页码
    },
    siderConfig() {
      return this.$store.state.siderConfig;
    },
  },
  watch: {
    "pageScroll.scroll": function (val, oldVal) {
      if (val) {
        if (this.pageScroll.mode == "auto") {
          const list = this.pageScroll.scrollList.filter(
            (item) => item.index == this.curPageNum + 1
          );
          if (
            list.length == 1 &&
            list[0].name != "imagePage" &&
            list[0].name != "deviceBigScreen" &&
            list[0].name != "indexBigScreen"
          ) {
            this.$refs[list[0].name].initData();
          }
        }
        this.pageTransition = "slide-left";
      } else {
        this.pageTransition = "el-fade-in-linear";
      }
    },
    curPageNum: function (val, oldVal) {
      if (this.pageScroll.mode == "auto") {
        let index = val + 1;
        if (this.pageScroll.scrollList.length < index) {
          index = 1;
        }
        const list = this.pageScroll.scrollList.filter(
          (item) => item.index == index
        );
        if (
          list.length == 1 &&
          list[0].name != "imagePage" &&
          list[0].name != "deviceBigScreen" &&
          list[0].name != "indexBigScreen"
        ) {
          this.$refs[list[0].name].initData();
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.fra {
  min-height: 0;
  flex: 1;
  &-sider {
    position: absolute;
    z-index: 1022;
    left: 0;
    top: 0;
    height: 100%;
  }
  &-header {
    position: absolute;
    z-index: 1022;
    left: 300px;
    right: 0;
    top: 0;
    transition: all 0.2s ease;
    // width: 100%;
    &.is-collapsed {
      left: 60px;
    }
  }
}
.scrolltool {
  position: absolute;
  z-index: 9999;
  left: 0;
  right: 0;
  width: 100%;
  // min-height: 100px;
  bottom: 0;
  text-align: center;
  transition: all 0.5s ease;
  background: rgba(#fff, 0.8);
  background: $--background-color-light;
  padding: 50px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  .el-button {
    padding: 1em;
  }
  h4 {
    font-size: $--font-size-large;
    margin-right: 8em;
  }
  &-num {
    margin: 0 1em;
  }
  .exit {
    min-width: 10em;
    margin-left: 8em;
  }
  &:hover {
    // background: rgba(#fff, 0.5);
    opacity: 1;
  }
}

//----------------------------
//  自适应
//----------------------------
@media screen and (max-width: $--lg) {
  .fra-header {
    left: 250px;
  }
}
</style>
